<div class="mark">
  <img src="/assets/images/toolhive-logo.svg" alt="" aria-hidden="true" />
</div>

<h2 mat-dialog-title class="title-large">Welcome to Toolhive! 🎉</h2>

<mat-dialog-content>
  <div class="intro body-medium">
    <p>We're excited to have you on board.</p>
    <p>Before you get started, please review and accept our latest Terms &amp; Conditions.</p>
  </div>
  <ul class="body-medium terms-version">
    <li>Terms version {{ currentTermsVersion().version }}</li>
  </ul>

  <mat-checkbox [checked]="confirmed()" (change)="confirmed.set($event.checked)">
    <span class="body-medium">
      I confirm that I have read and agree to Toolhive's
      <a
        class="terms-link"
        [href]="'https://www.home.sandvik/en/about-this-site/privacy/'"
        target="_blank"
        rel="noopener"
        >Privacy Policy</a
      >
      and
      <a
        class="terms-link"
        [href]="currentTermsVersion().documentUrl"
        target="_blank"
        rel="noopener"
        >Terms of Use</a
      >.
    </span>
  </mat-checkbox>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions>
  <button mat-stroked-button (click)="logOut()">Log out</button>
  <button
    mat-flat-button
    color="primary"
    class="accept-button"
    [disabled]="!confirmed()"
    (click)="acceptAndContinue()">
    Accept &amp; Continue
  </button>
</mat-dialog-actions>
